import React from "react";

import LandingFour from "./landings/l4";

const AppContainer = () => {
  return <LandingFour />;
};

export default AppContainer;
